// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExchangeStepAnswerButton_wrapper__2kfuG"};